









import Vue from 'vue';
import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import RelatedParts from '@/components/related-part/RelatedParts.vue';
import { RelatedPartsModuleTypes } from '@/store/modules/related-parts';

@Component({
    components: {
        RelatedParts,
    },
})
export default class RelatedPartsContainer extends Mixins(BaseMixin) {
    @Prop({ type: String, required: true })
    private fullPartId!: string;
    @Prop({ type: String, required: true })
    private partActionLink!: string;

    protected mounted(): void {
        this.$store.dispatch(RelatedPartsModuleTypes.actions.loadRelatedParts, {
            id: this.fullPartId,
        });
    }
}
